export const getXsrfToken = () => {
	return document.cookie
		.split('; ')
		.find(row => row.startsWith(`XSRF-TOKEN=SCORE.`))
		?.split('=')[1]
}
